export default __webpack_public_path__ + "static/media/envelope.8ef12838.png";